import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import CommonTable, { TableColumn } from "../../components/Table/CommonTable";
import {
  postDetails,
  postMultipartDetails,
} from "../../services/http/http.service";
import APIList from "../../utils/constants/APIList";
import { Trash3Fill, PlusCircleFill } from "react-bootstrap-icons";
import { Button, Modal } from "react-bootstrap";
import CroppingModal from "../../components/Cropping Modal/CroppingModal";
import CustomButton from "../../components/CustomButton/CustomButton";
import CustomDatePicker from "../../components/CustomDatePicker/CustomDatePicker";
import InputField from "../../components/InputField/InputField";
import PageHeader from "../../components/PageHeader/PageHeader";
import encrypt from "../../utils/helpers/encrypt";
import { validateImageFile } from "../../utils/helpers/validateFileUpload";
import { useNavigate } from "react-router-dom";
import { showLoader, hideLoader } from "../../store/Loader/loader.slice";
import { useAppDispatch } from "../../store/storeRequests";
import { hideToast, showToast } from "../../store/Toast/toast.slice";

export interface Video {
  id: number;
  folder_name: string;
  title: string;
  description: string;
  folder_image: string;
  status: number;
  report: any;
  // closeDate: string | number | Date;
}

export interface VideoChallengePayload {
  title: string;
  folder_name: string;
  description: string;
  closeDate?: string;
  id?: number;
}

const VideoChallengeData = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [showCroppingModal, setShowCroppingModal] = useState(false);
  const [folder_name, setFolder_name] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [folderImage, setFolderImage] = useState<{ value: any; src: string }>({
    value: null,
    src: "",
  });
  // const [closeDate, setCloseDate] = useState<Date | null>(null);
  const [selectedItems, setSelectedItems] = useState<Set<number>>(new Set());
  const [data, setData] = useState<Video[]>([]);
  const [isEditing, setIsEditing] = useState(false);
  const [currentItemId, setCurrentItemId] = useState<number | null>(null);
  const [imageChanged, setImageChanged] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [originalData, setOriginalData] =
    useState<VideoChallengePayload | null>(null);

  const cmpMounted = useRef(false);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (cmpMounted.current) return;
    cmpMounted.current = true;
    fetchVideoChallenges();
  }, []);

  const fetchVideoChallenges = async () => {
    try {
      dispatch(showLoader("Loading Data..."));
      const response = await postDetails(APIList.GET_ALL_VIDEOS_CHALLENGE, {});
      setData(response.data.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      dispatch(hideLoader());
    }
  };

  const handleShowModal = () => {
    setFolder_name("");
    setTitle("");
    setDescription("");
    setFolderImage({ value: null, src: "" });
    // setCloseDate(null);
    setIsEditing(false);
    setImageChanged(false);
    setCurrentItemId(null);
    setShowModal(true);
  };

  const handleCloseModal = () => setShowModal(false);
  const handleCloseDeleteModal = () => setShowDeleteModal(false);

  const handleFolderChange = (e: ChangeEvent<HTMLInputElement>) =>{
    const value = e.target.value;
    // if (/^[A-Za-z0-9\s&?()]*$/.test(value)) {
    setFolder_name(e.target.value);
    // }
}
  const handleTitleChange = (e: ChangeEvent<HTMLInputElement>) =>{
    const value = e.target.value;
    // if (/^[A-Za-z0-9\s]*$/.test(value)) {
    setTitle(e.target.value);
    // }
}
  const handleDescriptionChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => setDescription(e.target.value);

  const handleCoverImageChange = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];

    if (!file) return;

    const validation = validateImageFile(file);
    if (!validation.valid) {
      dispatch(showToast(validation.message));
      setTimeout(() => dispatch(hideToast()), 3000);
      return;
    }

    const maxSize = 10.1 * 1024 * 1024;
    if (file.size > maxSize) {
      // setErrorMessage(
      //   "File size exceeds the 10MB limit. Please upload a smaller file."
      // );
      dispatch(showToast("File size exceeds the 10MB limit. Please upload a smaller file."));
      setTimeout(() => dispatch(hideToast()), 3000);
      return;
    }

    setFolderImage({
      value: file,
      src: URL.createObjectURL(file),
    });
    setShowCroppingModal(true);
    setImageChanged(true);
  };

  const handleCrop = (croppedImage: string) => {
    setFolderImage((prev) => ({ ...prev, src: croppedImage }));
    setShowCroppingModal(false);
  };

  const handleCancelCrop = () => {
    // Close the cropping modal without setting the image
    // setFolderImage({ value: null, src: "" }); // Reset the folder image
    setFolderImage((prev) => ({ ...prev, value: null, src: "" }));
    setShowCroppingModal(false); // Close the cropping modal
  };

  const removeImage = () => {
    setFolderImage({ value: null, src: "" });
    setImageChanged(true);
  };

  const submitDetails = async (ev: React.FormEvent<HTMLFormElement>) => {
    ev.preventDefault();

    if (!isEditing && !folderImage.value) {
      dispatch(showToast("Please upload an Image."));
      setTimeout(() => dispatch(hideToast()), 3000);
      return;
    }

    if (!folder_name || !title || !description) {
      // setErrorMessage("Please fill in all fields.");
      dispatch(showToast("Please fill in all fields."));
      setTimeout(() => dispatch(hideToast()), 3000);
      return;
    }

    // const formattedCloseDate = closeDate?.toISOString();

    const trimmedFolderName = folder_name.trim();
    const trimmedTitle = title.trim();

    const payload: VideoChallengePayload = {
      title: trimmedTitle,
      folder_name: trimmedFolderName,
      description,
      // closeDate: formattedCloseDate,
    };

    if (isEditing && currentItemId !== null && originalData) {
      const noChanges =
        originalData.title === title &&
        originalData.folder_name === folder_name &&
        originalData.description === description &&
        // originalData.closeDate === formattedCloseDate &&
        !imageChanged;

      if (imageChanged && !folderImage.value) {
        dispatch(showToast("Please upload an Image."));
        setTimeout(() => dispatch(hideToast()), 3000);
        return;
      }

      if (noChanges) {
        dispatch(showToast("No Changes Done."));
        setTimeout(() => dispatch(hideToast()), 3000);
        // setShowModal(false);
        return;
      }

      payload.id = currentItemId;
    }

    const formData = new FormData();

    if (imageChanged && folderImage.value) {
      formData.append("mediafiles", folderImage.value);
    }

    formData.append("data", encrypt(payload));

    try {
      let response;

      if (isEditing && currentItemId !== null) {
        response = await postMultipartDetails(
          APIList.EDIT_VIDEO_CHALLENGE,
          formData
        );
        if (response.statusCode === 200) {
          dispatch(showToast("Updated Successfully."));
          setShowModal(false);
          // setFolder_name("");
          // setTitle("");
          // setDescription("");
          // setFolderImage({ value: null, src: "" });
          // setCloseDate(null);
          fetchVideoChallenges();
          setErrorMessage("");
        } else {
          dispatch(showToast(`Failed to Update : ${response.message}`));
        }
      } else {
        response = await postMultipartDetails(
          APIList.ADD_VIDEO_CHALLENGE,
          formData
        );
        if (response.statusCode === 200) {
          dispatch(showToast("Added Successfully."));
          setShowModal(false);
          setFolder_name("");
          setTitle("");
          setDescription("");
          setFolderImage({ value: null, src: "" });
          // setCloseDate(null);
          fetchVideoChallenges();
          setErrorMessage("");
        } else {
          dispatch(showToast(`Failed to Add : ${response.message}`));
        }
      }

      // console.log("Response:", response);
    } catch (error) {
      console.error("Error submitting details:", error);
      dispatch(showToast("Some error occurred while submitting data."));
    } finally {
      setTimeout(() => dispatch(hideToast()), 3000);
    }
  };

  const editItem = (item: Video) => {
    setFolder_name(item.folder_name);
    setTitle(item.title);
    setDescription(item.description);
    setFolderImage({ value: null, src: item.folder_image });
    // setCloseDate(new Date(item.closeDate));
    setIsEditing(true);
    setCurrentItemId(item.id);
    setOriginalData({
      title: item.title,
      folder_name: item.folder_name,
      description: item.description,
      // closeDate: item.closeDate.toString(),
    });
    setShowModal(true);
    setImageChanged(false);
    setErrorMessage("");
  };

  const handleBulkDelete = async () => {
    try {
      for (const id of selectedItems) {
        const itemToDelete = data.find((item) => item.id === id);
        if (itemToDelete) {
          await deleteItemById(itemToDelete);
        }
      }
      setSelectedItems(new Set());
      setShowDeleteModal(false);
    } catch (error) {
      console.error("Error deleting items:", error);
    }
  };

  const deleteItemById = async (item: Video) => {
    try {
      const response = await postDetails(
        APIList.DELETE_VIDEO_CHALLENGE_FOLDER,
        {
          id: item.id,
        }
      );
      // console.log("delete response", response);

      if (response.statusCode === 200) {
        setData((prevData) => prevData.filter((row) => row.id !== item.id));
        // console.log("Folder deleted");
        dispatch(showToast("Deleted Succesfully."));
      } else {
        dispatch(showToast(`Failed to Delete : ${response.message}`));
        console.log("Cannot delete folder");
        return;
      }
    } catch (error) {
      console.error("Error deleting folder:", error);
    } finally {
      setTimeout(() => dispatch(hideToast()), 3000);
    }
  };

  const toggleStatus = async (item: Video) => {
    try {
      const newStatus = item.status === 0 ? 1 : 0;
      const response = await postDetails(
        APIList.VIDEO_CHALLENGE_STATUS_UPDATE,
        {
          id: item.id,
          status: newStatus,
        }
      );
console.log("RESPONSE", response)
      if (response.statusCode === 200) {
        dispatch(showToast("Status Successfully Updated."));
      setTimeout(() => dispatch(hideToast()), 3000);
      setData((prevData) =>
        prevData.map((row) =>
          row.id === item.id ? { ...row, status: newStatus } : row
        )
      );
      console.log("Status updated");
    } else{
      dispatch(showToast("Cannot update status."));
      setTimeout(() => dispatch(hideToast()), 3000);
      console.log("Cannot update status");
      }

      
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  const handleCheckboxChange = (selectedIds: Set<number>) => {
    console.log(selectedIds);
    setSelectedItems(selectedIds);
  };

  const handleCancel = () => {
    setFolder_name("");
    setTitle("");
    setDescription("");
    setFolderImage({ value: null, src: "" });
    // setCloseDate(null);
    setShowModal(false);
  };

  // const handleCloseDateChange = (date: Date | null) => {
  //   setCloseDate(date);
  // };

  const handleViewVideos = (item: Video) => {
    const id = item?.id;
    if (id) {
      navigate(`/video-challenge/${id}`);
    } else {
      console.error("ID is undefined or item is not properly structured.");
    }
  };
  const columns: TableColumn[] = [
    // { key: "id", label: "ID", sortable: true, dataType: "string" },
    {
      key: "folder_name",
      label: "Folder Name",
      sortable: true,
      dataType: "string",
    },
    { key: "title", label: "Title", sortable: true, dataType: "string" },
    { key: "description", label: "Contest Text", dataType: "string" },
    { key: "folder_image", label: "Folder Image",
      //  dataType: "image"
      render: (item) => {
        if (item.folder_image) {
          return <img src={item.folder_image} alt="Profile" width={50}/>;
        }
      },
       },
    // { key: "closeDate", label: "Close Date" },
    {
      key: "",
      label: "Report",
      dataType: "button",
      button: {
        label: (item) => `View (${item.report?.Count || 0})`,
        onClick: handleViewVideos,
      },
    },
  ];

  const buttons = [
    {
      label: "Delete",
      theme: "danger",
      icon: <Trash3Fill />,
      onClick: () => setShowDeleteModal(true),
      disabled: selectedItems.size === 0,
    },
    {
      label: "Add New",
      theme: "warning",
      icon: <PlusCircleFill />,
      onClick: handleShowModal,
    },
  ];

  return (
    <div>
      <PageHeader buttons={buttons} />
      <CommonTable<Video>
        data={data}
        columns={columns}
        onView={(item) => console.log("View:", item)}
        onEdit={editItem}
        onDelete={deleteItemById}
        onStatusToggle={toggleStatus}
        pagination={true}
        rowsPerPage={10}
        actions={{
          view: false,
          edit: true,
          delete: true,
          checkbox: true,
          status: true,
          showModal: false,
        }}
        onCheckboxChange={handleCheckboxChange}
      />
      <Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            {isEditing ? "Edit" : "Add"} Video Challenge
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {errorMessage && (
            <div className="alert alert-danger" role="alert">
              {errorMessage}
            </div>
          )}
          <form onSubmit={submitDetails}>
            <div className="input-wrapper">
              <InputField
                name="folderName"
                label="Folder Name"
                type="text"
                value={folder_name}
                placeholder="Enter Folder Name"
                maxLength={50}
                required={true}
                onChangeInput={handleFolderChange}
              />
              <div className="character-counter">
                {folder_name.length}/{50}
              </div>
            </div>

            <div className="input-wrapper">
              <InputField
                name="title"
                label="Title"
                type="text"
                value={title}
                placeholder="Enter Title"
                maxLength={50}
                required={true}
                onChangeInput={handleTitleChange}
              />
              <div className="character-counter">
                {title.length}/{50}
              </div>
            </div>

            <div className="input-wrapper">
              <InputField
                name="description"
                label="Description"
                type="text"
                value={description}
                placeholder="Enter Description"
                maxLength={150}
                required={true}
                onChangeInput={handleDescriptionChange}
              />
              <div className="character-counter">
                {description.length}/{150}
              </div>
            </div>
            {/* <CustomDatePicker
              label="Close Date"
              name="closeDate"
              required={true}
              dateFormat={"MMMM d, yyyy"}
              onChange={handleCloseDateChange}
              defaultDate={closeDate}
            /> */}
            <div className="upload-information mb-4">
              <p className="font-14 mb-4 text-danger fw-bold">
                Uploads must be JPG / JPEG / PNG
                <span style={{ color: "red", fontWeight: "bold" }}>*</span>
              </p>
              <div className="mb-2">
                <div className="upload-image-wrapper d-flex flex-column">
                  {folderImage.src && (
                    <>
                      {/* <span
                        className="remove-image-btn font-14 cursor-pointer"
                        onClick={removeImage}
                      >
                        Remove
                      </span> */}
                      <img
                        src={folderImage.src}
                        alt="video-challenge-image"
                        width={150}
                      />
                    </>
                  )}
                </div>
              </div>
              <label htmlFor="photo">
                <div className="upload-btn-wrapper font-14 d-flex align-items-center justify-content-center gap-1">
                  <i className="fa-regular fa-image"></i>
                  <span>
                    {folderImage.src ? "Change Photo" : "Upload Folder Image"}
                  </span>
                </div>
              </label>
              <InputField
                type="file"
                name="photo"
                id="photo"
                value={""}
                className="d-none"
                onChangeInput={handleCoverImageChange}
              />
            </div>
            <div className="add-video-challenge-btn-bottom d-flex flex-column-reverse flex-md-row align-items-md-center justify-content-md-center gap-3 mb-5">
              <CustomButton theme="red" size="md" onClick={handleCancel}>
                Cancel
              </CustomButton>
              <CustomButton theme="yellow" size="md" type="submit">
                Submit
              </CustomButton>
            </div>
          </form>
        </Modal.Body>
      </Modal>

      <Modal
        show={showDeleteModal}
        onHide={handleCloseDeleteModal}
        centered
        className="deleteAll-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to delete?</p>
          <Button className="btn-danger" onClick={handleBulkDelete}>
            Delete
          </Button>
          <Button
            className="btn-warning text-white"
            onClick={handleCloseDeleteModal}
          >
            Cancel
          </Button>
        </Modal.Body>
      </Modal>

      {/* Cropping Modal */}
      {folderImage.value && (
        <CroppingModal
          show={showCroppingModal}
          handleClose={() => setShowCroppingModal(false)}
          image={folderImage.src}
          onCrop={handleCrop}
          onCancel={handleCancelCrop}
        />
      )}
    </div>
  );
};

export default VideoChallengeData;
